import type { SystemService } from '@mathcore/math3d';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface IAlgebra3DState {
  loading: boolean;
  systemService: SystemService | null;
}

const algebra3dSlice = createSliceSteamup(
  'algebra3d',
  {
    loading: true,
    systemService: null,
  } as IAlgebra3DState,
  {
    init(state, { payload }: PayloadAction<SystemService>) {
      return {
        ...state,
        systemService: payload,
      };
    },
    destroy(state) {
      return {
        ...state,
        systemService: null,
      };
    },
  },
);

export default algebra3dSlice;
